export var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus[UserAccountStatus["any"] = 0] = "any";
    UserAccountStatus[UserAccountStatus["active"] = 1] = "active";
    UserAccountStatus[UserAccountStatus["authorized"] = 2] = "authorized";
    UserAccountStatus[UserAccountStatus["activeAuthorized"] = 3] = "activeAuthorized";
})(UserAccountStatus || (UserAccountStatus = {}));
